/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor} from '../../../theme/theme';
import {LayerOpacitySlider} from '../../layers/LayerOpacitySlider';
import {LayerSettingsSubLayersProps} from '../../layers/LayerSettings';

const useStyles = makeStyles(() => ({
  subLayersSlider : {
    width     : '95%',
    display   : 'block',
    marginTop : '25px'
  },
  subLayersHeader : {
    fontFamily    : 'Roboto',
    fontStyle     : 'normal',
    fontWeight    : 500,
    fontSize      : '10px',
    lineHeight    : '16px',
    letterSpacing : '1px',
    textTransform : 'uppercase',
    display       : 'inline-block',
    color         : dlsColor('grey2')
  }
}));

const Opacity = ({
  opacity = 1,
  changeOpacity,
  title
}: LayerSettingsSubLayersProps) => {
  const [value, setValue] = useState(opacity);

  useEffect(() => {
    setValue(opacity);
  }, [opacity]);

  useEffect(() => {
    changeOpacity({title, opacity: value});
  }, [value]);

  const classes: any = useStyles();

  const onOpacitySlide = function(e, value) {
    setValue(value);
  };

  return (
    <div style={{marginTop: '-20px'}}>
      <LayerOpacitySlider className={classes.subLayersSlider}
        headerClassName={classes.subLayersHeader}
        label={translate('maps:operationalLayers.opacity')}
        value={value}
        onSlide={onOpacitySlide} />
    </div>
  );
};

export default Opacity;
